import StaticContent from './StaticContent';

export default StaticContent;



// WEBPACK FOOTER //
// ./src/StaticContent/index.js